import { CoinflipChoice } from '@/__generated__/graphql'
import { Box, Flex, Icon } from '@chakra-ui/react'
import { memo, forwardRef } from 'react'
import CoinEmptyIcon from '@/public/assets/images/coinflip/coin-empty.svg'
import CoinHeadIcon from '@/public/assets/images/coinflip/coin-head.svg'
import CoinTailsIcon from '@/public/assets/images/coinflip/coin-tail.svg'
import CoinHeadLoseIcon from '@/public/assets/images/coinflip/coin-head-lose.svg'
import CoinTailsLoseIcon from '@/public/assets/images/coinflip/coin-tail-lose.svg'
import React from 'react'

export const StepBadge = memo(
  forwardRef(
    (
      { multiplier, coin, isLost = false }: { multiplier: string; coin?: CoinflipChoice; isLost?: boolean },
      ref: any
    ) => {
      return (
        <Box ref={ref} h={'full'} py={{ base: 0, md: 1 }} px={'px'} position={'relative'}>
          <Flex
            flexShrink={0}
            px={3}
            py={{ base: 1.5, md: 2.5 }}
            pl={{ base: '36px', md: '44px' }}
            bg={'rgba(255, 255, 255, 0.01)'}
            boxShadow={`0px -12px 20px -14px ${mapColor(isLost, coin)} inset;`}
            rounded={'2xl'}
            alignItems={'center'}
            fontWeight={700}
            transition={'0.2s'}
            fontSize={'xs'}
            cursor={'default'}
            userSelect={'none'}
            lineHeight={'16px'}
          >
            x{multiplier}
          </Flex>
          <Icon
            pos={'absolute'}
            top={{ base: 0, md: 1 }}
            left={0}
            w={{ base: 7, md: 9 }}
            h={{ base: 7, md: 9 }}
            as={CoinEmptyIcon}
          />
          <Icon
            opacity={!isLost && coin === CoinflipChoice.Heads ? 1 : 0}
            transition={'0.2s'}
            pos={'absolute'}
            top={{ base: 0, md: 1 }}
            left={0}
            w={{ base: 7, md: 9 }}
            h={{ base: 7, md: 9 }}
            as={CoinHeadIcon}
          />
          <Icon
            opacity={!isLost && coin === CoinflipChoice.Tails ? 1 : 0}
            transition={'0.2s'}
            pos={'absolute'}
            top={{ base: 0, md: 1 }}
            left={0}
            w={{ base: 7, md: 9 }}
            h={{ base: 7, md: 9 }}
            as={CoinTailsIcon}
          />
          <Icon
            opacity={isLost && coin === CoinflipChoice.Tails ? 1 : 0}
            transition={'0.2s'}
            pos={'absolute'}
            top={{ base: 0, md: 1 }}
            left={0}
            w={{ base: 7, md: 9 }}
            h={{ base: 7, md: 9 }}
            as={CoinTailsLoseIcon}
          />
          <Icon
            opacity={isLost && coin === CoinflipChoice.Heads ? 1 : 0}
            transition={'0.2s'}
            pos={'absolute'}
            top={{ base: 0, md: 1 }}
            left={0}
            w={{ base: 7, md: 9 }}
            h={{ base: 7, md: 9 }}
            as={CoinHeadLoseIcon}
          />
        </Box>
      )
    }
  )
)

export const StepCoinBadge = memo(
  forwardRef(
    (
      {
        amount,
        icon,
        coin,
        isLost = false,
      }: { amount: string; isLost?: boolean; coin?: CoinflipChoice; icon?: React.ReactElement },
      ref: any
    ) => {
      return (
        <Box flexShrink={0} ref={ref} h={'full'} py={{ base: 0, md: 1 }} px={'px'} position={'relative'}>
          <Flex
            flexShrink={0}
            px={3}
            py={{ base: 1.5, md: 2.5 }}
            pl={{ base: '36px', md: '44px' }}
            bg={'rgba(255, 255, 255, 0.01)'}
            boxShadow={`0px -12px 20px -14px ${mapColor(isLost, coin)} inset;`}
            rounded={'2xl'}
            alignItems={'center'}
            fontWeight={700}
            transition={'0.2s'}
            fontSize={'xs'}
            cursor={'default'}
            userSelect={'none'}
            lineHeight={'16px'}
            gap={1.5}
          >
            {React.createElement(() => icon, {})}
            {amount}
          </Flex>
          <Icon
            pos={'absolute'}
            top={{ base: 0, md: 1 }}
            left={0}
            w={{ base: 7, md: 9 }}
            h={{ base: 7, md: 9 }}
            as={CoinEmptyIcon}
          />
          <Icon
            opacity={coin === CoinflipChoice.Heads ? 1 : 0}
            transition={'0.2s'}
            pos={'absolute'}
            top={{ base: 0, md: 1 }}
            left={0}
            w={{ base: 7, md: 9 }}
            h={{ base: 7, md: 9 }}
            as={CoinHeadIcon}
          />
          <Icon
            opacity={coin === CoinflipChoice.Tails ? 1 : 0}
            transition={'0.2s'}
            pos={'absolute'}
            top={{ base: 0, md: 1 }}
            left={0}
            w={{ base: 7, md: 9 }}
            h={{ base: 7, md: 9 }}
            as={CoinTailsIcon}
          />
        </Box>
      )
    }
  )
)

const mapColor = (isLost: boolean, coin?: CoinflipChoice) => {
  if (isLost) {
    return '#FF3288'
  }

  if (coin === CoinflipChoice.Heads) {
    return '#8E83FB'
  }

  if (coin === CoinflipChoice.Tails) {
    return '#E983FB'
  }

  return 'rgba(255, 255, 255, 0.24)'
}
